import React, {Fragment, useState} from "react";

// components
import NestedPaginatedTable from "../../../../Common/Legacy/NestedPaginatedTable";

import SecondLevel from "./SecondLevel";
import {toFixedDate, toStackedBarChart} from "../../../../../utils/reactFunctions";
import {CompositeFilterDescriptor} from "@progress/kendo-data-query";

interface Props {
  tableData: any[];
  fetchingSellerStats: boolean;
  sendFilters: () => void;
  take: number;
  skip: number;
  total: number;
  activeFilters: CompositeFilterDescriptor;
  featuresAllowed: string[];
}

export default (props: Props) => {
  const initialSortValue = [
    {field: null, dir: null},
  ];
  const [sort, setSort] = useState(initialSortValue);

  const tableConfig = (firstColumnName: string) => {
    return [
      {
        headTitle: firstColumnName,
        rowValue: "sellerId",
      },
      {
        headTitle: 'NOMBRE VENDEDOR',
        rowValue: "sellerName",
      },
      {
        headTitle: 'NOMBRE SUPERVISOR',
        rowValue: "supervisorName",
      },
      {
        headTitle: 'NOMBRE LIDER',
        rowValue: "leaderName",
      },
      {
        headTitle: 'FECHA ÚLTIMO PEDIDO',
        rowValue: "lastOrderDate",
        custom: toFixedDate,
      },
      {
        headTitle: 'FUENTES',
        rowValue: "sourcePercentages",
        custom: toStackedBarChart,
      },
      {
        headTitle: 'CLIENTES TOTALES',
        rowValue: "totalClients",
      },
    ];
  };

  return (
    <Fragment>
      <NestedPaginatedTable
        tableConfig={tableConfig('ID VENDEDOR')}
        tableData={props.tableData}
        loading={props.fetchingSellerStats}
        detailComponent={(detailProps) => SecondLevel({dataItem: detailProps.dataItem, activeFilters: props.activeFilters, featuresAllowed:props.featuresAllowed})}
        requestNewPage={props.sendFilters}
        take={props.take}
        skip={props.skip}
        total={props.total}
        sort={sort}
        setSort={setSort}
      />
    </Fragment>
  );
};
